import {requestStarted, requestSuccessful, requestFailed, getFromHub, mockFromHub} from './actions';
import { reducer } from './reducer';
import {useEffect, useReducer} from "react";

export const useGet = (url, reloadTriggerCount = 1) => {
    const [state, dispatch] = useReducer(reducer, {
        isLoading: false,
        data: null,
        error: null,
    });

    useEffect(() => {
        let isCancelled = false;

        const fetchData = async () => {
            dispatch(requestStarted());

            try {
                //handle multiple requests
                if(typeof url === 'object' && url !== null) {
                    let requests = [];
                    const requestKeys = Object.keys(url);
                    for (let key of requestKeys) {
                        if(url[key].startsWith("mock/")) {
                            requests.push(mockFromHub(url[key]));
                        }
                        else {
                            requests.push(getFromHub(url[key]));
                        }
                    }

                    //wait for all requests to resolve
                    const responses = await Promise.all(requests);

                    //map the responses to the keys in the url to be consumed by components
                    const data = responses.reduce((result, response, index) => {
                        result[requestKeys[index]] = response;
                        return result;
                    }, {});

                    if(!isCancelled) {
                        dispatch(requestSuccessful({ data }));
                    }
                }

                //simple request
                else {
                    if(url === null || url === undefined) {
                        dispatch(requestSuccessful({data: null}));
                    }
                    else {
                        let data;
                        if(url.startsWith("mock/")) {
                            data = await mockFromHub(url);
                        }
                        else {
                            data = await getFromHub(url);
                        }
                        if(!isCancelled) {
                            dispatch(requestSuccessful({data}));
                        }
                    }
                }
            } catch (e) {
                console.log("error happened", e);
                if(!isCancelled) {
                    dispatch(requestFailed({error: e.message}));
                }
            }
        };

        fetchData();

        // basic cleanup
        // TODO - implement cancellation of the underlying network request if need be
        return () => {
            isCancelled = true;
        };
    }, [url, reloadTriggerCount]);

    return state;
};